import type { OnboardingSection } from "@qendo/onboarded";
import { type Href, router } from "expo-router";
import { HeaderButton } from "~/components/HeaderButton";
import { useDismiss } from "~/providers/DismissProvider";
import { useOnboarding } from "~/providers/OnboardingProvider";
import { filled } from "~/util";

export type OnboardingSkipProps = {
    next?: Href;
    section?: OnboardingSection;
};

export const OnboardingSkip = ({ next, section }: OnboardingSkipProps) => {
    const { dismiss } = useOnboarding();
    const { handleDismiss } = useDismiss();

    const onSkip = () => {
        dismiss(section ?? "cycle");
        if (filled(next)) {
            router.replace(next);
        } else {
            handleDismiss();
        }
    };

    return <HeaderButton onPress={onSkip} title="Skip" />;
};
